import { SET_CLIENT_SECTIONS } from '../actions/types'

const initialState = []

const sectionDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLIENT_SECTIONS:
      return action.payload
    default:
      return state
  }
}

export default sectionDataReducer
